import React, {
  useState, useContext, useEffect,
} from 'react';
import moment from 'moment-timezone';
import { Link, useParams, useHistory } from 'react-router-dom';
import {
  Button,
} from '@mui/material';
import { UnfoldMore } from '@mui/icons-material/';
import NavigationLayout from '../../components/NavigationLayout';
import API from '../../api/endpoints';
import { sendRequest } from '../../api/shootAPI';
import { UserContext } from '../../contexts/User';
import { NotificationContext } from '../../contexts/Notification';
import ChangePasswordModal from './ChangePasswordModal';
import ChangeDetailsModal from './ChangeDetailsModal';
import FaceRegister from './FaceRegister';
import UserIcon from '../../images/UserspaceM.png';
import PasswordIcon from '../../images/password.png';
import DeviceIcon from '../../images/device.png';
import FaceIcon from '../../images/face.png';
import TimesheetsIcon from '../../images/timesheets.png';
import AlertIcon from '../../images/alert.png';
import ViewActivityTable from './ViewActivityTable';
import {
  getDatesInRange, getWeekRange, convertSecToTimeFormat, currentMonthWeekRange,
  formatDate,
} from '../../utils/time';
import CustomTable from '../../components/table/CustomTable';
import ViewIssueModal from '../alerts/ViewIssueModal';
import './account.css';

const _ = require('lodash');

const TABLE_HEADERS = [
  {
    label: 'Alert Type',
    sortable: true,
    sortIcon: UnfoldMore,
    sortKey: 'category',
    colSpan: 1,
  },
  {
    label: 'Issue Description',
    sortable: false,
    sortIcon: UnfoldMore,
    colSpan: 2,
  },
  {
    label: 'Status',
    sortable: true,
    sortIcon: UnfoldMore,
    sortKey: 'status',
    colSpan: 0.5,
  },
  {
    label: 'Acknowledged',
    sortable: true,
    sortIcon: UnfoldMore,
    sortKey: 'acknowledged',
    colSpan: 1,
  },
  {
    label: 'Date',
    sortable: true,
    sortIcon: UnfoldMore,
    sortKey: 'date',
    colSpan: 0.5,
  },
  {
    label: 'Action',
    colSpan: 0.5,
  },
];

const CustomTableStyles = {
  container: {
    marginTop: 1,
  },
  header: {
    backgroundColor: 'var(--dark-10)',
    fontSize: '14px',
    '.MuiTableSortLabel-iconDirectionAsc': {
      transform: 'rotate(0deg) !important',
    },
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#fff !important',
    },
    '&:hover': {
      backgroundColor: 'var(--dark-10) !important',
    },
  },
  cell: {
    button: {
      textWrap: 'nowrap',
      color: 'var(--dark-2)',
      borderColor: 'var(--dark-4) !important',
      '&:disabled': {
        color: 'var(--dark-5)',
        borderColor: 'var(--dark-7) !important',
        cursor: 'not-allowed',
        pointerEvents: 'all !important',
      },
    },
  },
};

function Account() {
  const {
    activeWorkspace, member,
  } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);
  const [user, setUser] = useState({});
  const [formData, setFormData] = useState({});
  const [isProfilePage, setIsProfilePage] = useState(false);
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showChangeDetailsModal, setShowChangeDetailsModal] = useState(false);
  const [showFaceIdSetupModal, setShowFaceIdSetupModal] = useState(false);
  const [faceIdDataPath, setFaceIdDataPath] = useState('');
  const [location, setLocation] = useState({});
  const [date, setDate] = useState(new Date());
  const [profileUpdateRequests, setProfileUpdateRequests] = useState(null);
  const [tableData, setTableData] = useState({
    dates: [], times: [], avgActivities: [], totalTime: '0:00:00', totalAvgActivity: null,
  });
  const [workspaceMember, setWorkspaceMember] = useState(member);
  const [pwdUpdateTime, setPwdUpdateTime] = useState();
  const [diffInDays, setDiffInDays] = useState(0);
  const [diffInHours, setDiffInHours] = useState(0);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const curdate = currentMonthWeekRange();
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const [selectedAlert, setSelectedAlert] = useState({});
  const [acknowledgement, setAcknowledgement] = useState([]);
  const { id } = useParams();
  const history = useHistory();

  const onClickView = (alert) => {
    setSelectedAlert(alert);
    setIsOpenModal(true);
  };

  const handleClose = () => {
    setIsOpenModal(false);
  };

  useEffect(() => setUser(workspaceMember.user), [workspaceMember]);

  const getTableTimeAndAcitivity = (activities, dates, timezone) => {
    const times = [];
    const avgActivities = [];
    let totalSecondsElapsed = 0;
    let totalActiveSeconds = 0;
    dates.forEach((day) => {
      // get total active time for each date
      const startDay = moment.tz(day, 'MM/DD/YYYY', timezone).startOf('day').utc();
      const endDay = moment.tz(day, 'MM/DD/YYYY', timezone).endOf('day').utc();
      const initialdateActivity = { secondsElapsed: 0, activeSeconds: 0 };
      const dateActivity = activities.reduce(
        (acc, activity) => {
          // Check if the time is within the local day range
          const compareDay = moment.utc(activity.startDate);

          if (compareDay.isSameOrAfter(startDay) && compareDay.isSameOrBefore(endDay)) {
            return {
              secondsElapsed: acc.secondsElapsed + activity.secondsElapsed,
              activeSeconds: acc.activeSeconds + activity.activeSeconds,
            };
          }
          return { ...acc };
        },
        initialdateActivity,
      );
      totalSecondsElapsed += dateActivity.secondsElapsed;
      totalActiveSeconds += dateActivity.activeSeconds;
      times.push(moment.utc(dateActivity.secondsElapsed * 1000).format('H:mm:ss'));
      const avgActivity = dateActivity.secondsElapsed
        ? Number((((dateActivity.activeSeconds / dateActivity.secondsElapsed) || 0) * 100).toFixed(0))
        : null;
      avgActivities.push(avgActivity);
    });
    const totalTime = convertSecToTimeFormat(totalSecondsElapsed);
    const totalAvgActivity = totalSecondsElapsed
      ? Number((((totalActiveSeconds / totalSecondsElapsed) || 0) * 100).toFixed(0))
      : null;
    return {
      times, avgActivities, totalTime, totalAvgActivity,
    };
  };

  const getTableData = async (selectedDate) => {
    const weekRange = getWeekRange(selectedDate);
    const dates = getDatesInRange(new Date(weekRange.start), new Date(weekRange.end));
    const startOfDate = moment(dates[0]).startOf('day');
    const endOfDate = moment(dates[6]).endOf('day');
    const params = {
      start: startOfDate.format('YYYY-MM-DD HH:mm:ss'),
      end: endOfDate.format('YYYY-MM-DD HH:mm:ss'),
      timezone: activeWorkspace.timezone,
    };

    const res = await sendRequest({ method: 'get', url: API.MEMBER.activityList(workspaceMember.id), params });
    if (res.success) {
      const data = res?.data?.list || [];
      const {
        times, avgActivities, totalTime, totalAvgActivity,
      } = getTableTimeAndAcitivity(data, dates, activeWorkspace.timezone);
      setTableData({
        dates, times, avgActivities, totalTime, totalAvgActivity,
      });
    }
  };

  const handleSelectDate = async (selectedDate) => {
    setDate(selectedDate);
    getTableData(selectedDate, activeWorkspace.timezone);
  };

  const fetchMemberInfo = async (memberId) => {
    const res = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.getMember(activeWorkspace.id, memberId),
    });
    if (res.success) {
      setFormData(res.data.member.user);
      setWorkspaceMember(res.data.member);
    } else if (res.status === 400) {
      displayNotification({
        message: res.data.error,
        severity: 'error',
      });
    } else if (res.status === 403) {
      displayNotification({
        message: 'You are not authorized to view this page',
        severity: 'error',
      });
      history.push('/');
    }
  };

  const fetchFaceIdData = async () => {
    const { success, data } = await sendRequest({
      method: 'get',
      url: API.USER.fetchMemberFaceIdData(workspaceMember.id),
    });
    if (success) {
      if (data.faceIdData) {
        setFaceIdDataPath(data.faceIdData.image_path);
      }
      if (data.location) {
        setLocation(data.location);
      }
      if (data.profileUpdateRequests) {
        const keyedProfileUpdateRequests = _.keyBy(data.profileUpdateRequests, 'profile_field');
        setProfileUpdateRequests(keyedProfileUpdateRequests);
      }
    }
  };

  const fetchPassword = async () => {
    const { success, data } = await sendRequest({
      method: 'get',
      url: API.USER.getpasswordupdateat,
      params: { id: activeWorkspace.id },
    });
    if (success) {
      setPwdUpdateTime(data.time);
    }
  };

  const fetchAcknowledgement = async () => {
    const res = await sendRequest({ method: 'get', url: API.WORKSPACE.getAcknowledgement() });
    if (res.success) {
      setAcknowledgement(res.data.acknowledgement);
    }
  };

  const getAlerts = async (memberId) => {
    setIsLoading(true);
    const [startDate, endDate] = curdate;
    const dates = getDatesInRange(startDate, endDate);
    const startOfDay = moment(dates[0]).utc().startOf('day')
      .format('YYYY-MM-DD HH:mm:ss');
    const endOfDay = moment(dates.at(-1)).utc().endOf('day')
      .format('YYYY-MM-DD HH:mm:ss');

    const response = await sendRequest({
      method: 'get',
      url: API.WORKSPACE.getAlertOfMember(activeWorkspace.id),
      params: {
        startOfDay,
        endOfDay,
        memberId,
      },
    });

    if (response.success) {
      const mappedAlerts = response.data?.alerts.map((alert) => {
        const id = alert?.id;
        const category = alert?.category;
        const alertMessageInternal = alert?.alertMessageInternal;
        const status = alert?.status;
        const date = alert?.date;

        let flag = false;
        acknowledgement.forEach((ack) => {
          if (ack.alertId === id) {
            flag = true;
          }
        });

        const acknowledged = flag ? 'Yes' : 'No';

        return {
          category: `${category} Alert`,
          alertMessageInternal,
          curStatus: (
            <div
              className={
                // eslint-disable-next-line no-nested-ternary
                status === 'Pending'
                  ? 'primaryBadge' : status === 'Open'
                    ? 'errorBadge' : 'successBadge'
              }
            >
              {status}
            </div>
          ),
          acknowledged,
          date: formatDate(date),
          actions: (
            <Button
              type="button"
              className="inactive-status"
              onClick={() => onClickView(alert)}
              variant="outlined"
            >
              View Issue
            </Button>
          ),
        };
      });
      setIsLoading(false);
      setAlerts(mappedAlerts);
    }
  };

  const handleMarkAsAcknowledged = async () => {
    setIsUpdating(true);
    const response = await sendRequest({
      method: 'put',
      url: API.WORKSPACE.acknowledgedByManager(selectedAlert?.id),
    });
    setIsUpdating(false);
    if (response.success) {
      setIsOpenModal(false);
      getAlerts(workspaceMember.id);
    } else {
      // handle API errors
    }
  };

  useEffect(() => {
    const timeDiff = Math.abs(new Date() - new Date(pwdUpdateTime));
    setDiffInHours(Math.floor(timeDiff / (1000 * 60 * 60)));
    setDiffInDays(Math.floor(timeDiff / (1000 * 60 * 60) / 24));
  }, [pwdUpdateTime]);

  useEffect(() => {
    handleSelectDate(date);
    getAlerts(workspaceMember.id);
    fetchAcknowledgement();
  }, [workspaceMember]);

  useEffect(() => {
    if (workspaceMember) {
      fetchPassword();
      fetchFaceIdData();
    }

    // fetchActivity();
    // fetchPendingFaceIdRequest();
  }, [workspaceMember]);

  useEffect(() => {
    let memberId = null;
    if (id) {
      memberId = id;
      setIsProfilePage(true);
    } else {
      memberId = member.id;
    }
    fetchMemberInfo(memberId);
  }, [id]);

  const getReadableAppVersion = (appVersionString) => {
    if (!appVersionString) return '';

    const [appVersion, platform, user, hostname] = appVersionString.split('__');

    const platformMap = {
      darwin: '🍎 macOS',
      win32: '🪟 Windows',
      linux: '🐧 Linux',
    };

    // Get platform display text with fallback
    const platformText = platformMap[platform] || `💻 ${platform}`;

    // Build user@host component if available
    const userHost = [user, hostname].filter(Boolean).join(':');

    // Combine all parts
    return [
      platformText,
      userHost,
      appVersion ? `Shoot V${appVersion}` : '',
    ]
      .filter(Boolean)
      .join(', ');
  };

  return (
    <div>
      {showChangePasswordModal
        && (
          <ChangePasswordModal
            email={user.email}
            closeModal={() => setShowChangePasswordModal(false)}
          />
        )}

      {showChangeDetailsModal
        && (
          <ChangeDetailsModal
            formData={formData}
            address={location}
            setFormData={setFormData}
            profileUpdateRequests={profileUpdateRequests}
            fetchFaceIdData={fetchFaceIdData}
            closeModal={() => setShowChangeDetailsModal(false)}
          />
        )}

      {showFaceIdSetupModal ? (
        <FaceRegister
          closeModal={() => setShowFaceIdSetupModal(false)}
          setPath={fetchFaceIdData}
        />
      ) : null}

      <div className="account">
        <NavigationLayout title="My Account">
          <div className="body">
            <div className="user">
              <div className="texts">
                <img className="avatar" src={formData.avatar} alt="" />
                <div className="title">
                  <div className="name">
                    {formData.firstName}
                    {' '}
                    {formData.lastName}
                  </div>
                  <div className="email">
                    {formData.email}
                  </div>
                  <div className="description">
                    Last active
                    {' '}
                    { moment(workspaceMember.recentActivityTime).fromNow() }
                  </div>
                </div>
              </div>
              {!isProfilePage && (
                <Button
                  className="button"
                  onClick={() => setShowChangeDetailsModal(true)}
                >
                  Edit
                </Button>
              )}

            </div>
            <div className="details">
              <div className="options">
                <div className="basic">
                  <div className="header">
                    <div className="group">
                      <img className="icon" src={UserIcon} alt="" />
                      <div className="title">
                        Basic Details
                      </div>
                    </div>
                    {!isProfilePage && (
                      <Button
                        className="button"
                        onClick={() => setShowChangeDetailsModal(true)}
                      >
                        Edit
                      </Button>
                    )}
                  </div>
                  <div className="body">
                    <div className="text">
                      <div className="title">
                        Date of Birth:
                      </div>
                      <div className="description">
                        {formData?.birthday}
                      </div>
                    </div>

                    <div className="text">
                      <div className="title">
                        Current Address:
                      </div>
                      <div className="description">
                        {location.description}
                      </div>
                    </div>

                    <div className="text">
                      <div className="title">
                        Employment Start Date:
                      </div>
                      <div className="description">
                        {workspaceMember.employmentStartDate}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="password">
                  <div className="header">
                    <div className="group">
                      <img className="icon" src={PasswordIcon} alt="" />
                      <div className="title">
                        Password
                      </div>
                    </div>
                    {!isProfilePage && (
                      <Button
                        className="button"
                        onClick={() => setShowChangePasswordModal(true)}
                      >
                        Update
                      </Button>
                    )}

                  </div>
                  <div className="body">
                    <div className="description">
                      Your password was changed
                      {' '}
                      {
                        // eslint-disable-next-line no-nested-ternary
                        diffInDays
                          ? `${diffInDays} day${diffInDays === 1 ? ' ago' : 's ago'}`
                          : diffInHours
                            ? `${diffInHours} hour${diffInHours === 1 ? ' ago' : 's ago'}`
                            : ' now'
                      }
                    </div>
                  </div>
                </div>
                <div className="device-info">
                  <div className="header">
                    <div className="group">
                      <img className="icon" src={DeviceIcon} alt="" />
                      <div className="title">
                        Device Information
                      </div>
                    </div>
                  </div>
                  <div className="body">
                    <div className="description">
                      {getReadableAppVersion(workspaceMember.appVersion)}
                    </div>
                  </div>
                </div>
              </div>
              <div className="face">
                <div className="header">
                  <div className="group">
                    <img className="icon" src={FaceIcon} alt="" />
                    <div className="title">
                      Current Face ID
                    </div>
                    {!faceIdDataPath ? (
                      <div className="badge error">
                        Not Registered
                      </div>
                    ) : (
                      <div className="badge success">
                        Verified
                      </div>
                    )}
                  </div>
                  {!isProfilePage && (
                  <Button
                    className="button"
                    onClick={() => setShowFaceIdSetupModal(true)}
                  >
                    Update
                  </Button>
                  )}

                </div>
                <div className="body">
                  <div className="description">
                    {
                      // eslint-disable-next-line no-nested-ternary
                      profileUpdateRequests?.face_id
                        ? (
                          <span style={{ color: 'red' }}>
                            New changes submitted. New changes will apply after approval.
                          </span>
                        )
                        : faceIdDataPath
                          ? 'Current Face ID registered and verified. Update if needed.'
                          : 'Face ID is not registered yet!'
                    }
                  </div>
                  <div className="d-flex w-100 justify-content-between">
                    {
                    faceIdDataPath && (
                      <img className="img" src={faceIdDataPath} alt="" />
                    )
                  }
                    {
                      (profileUpdateRequests && profileUpdateRequests.face_id) && (
                      <img className="img" src={profileUpdateRequests.face_id.new_value.image_path} alt="" />
                      )
                  }
                  </div>
                </div>
              </div>
            </div>
            <div className="timesheets">
              <div className="header">
                <div className="group">
                  <img className="icon" src={TimesheetsIcon} alt="" />
                  <div className="title">
                    Timesheets
                  </div>
                </div>
                <Link className="button" to={`/members/activity/view?member=${workspaceMember.id}`}>
                  View Detailed Timesheets
                </Link>
              </div>
              <div className="body">
                {(tableData.times.length > 0 && tableData.avgActivities.length > 0) && (
                  <ViewActivityTable
                    tableData={tableData}
                    date={date}
                    handleSelectDate={handleSelectDate}
                    workspaceMember={workspaceMember}
                  />
                )}
              </div>
            </div>
            <div className="alerts mb-3">
              <div className="header">
                <div className="group">
                  <img className="icon" src={AlertIcon} alt="" />
                  <div className="title">
                    Recent Alerts
                  </div>
                </div>
              </div>
              <div className="body">
                <div className="w-100">
                  <CustomTable
                    headers={TABLE_HEADERS}
                    items={alerts}
                    loading={isLoading}
                    styles={CustomTableStyles}
                  />
                </div>
                {isOpenModal && (
                  <ViewIssueModal
                    selectedAlert={selectedAlert}
                    isOpen={isOpenModal}
                    handleClose={handleClose}
                    handleMarkAsAcknowledged={handleMarkAsAcknowledged}
                    isUpdating={isUpdating}
                  />
                )}
              </div>
            </div>
          </div>
        </NavigationLayout>
      </div>
    </div>
  );
}

export default Account;
